/**
 * 注意メッセージ
 */
export const WARNING = {
  CAN_WRECKER:
    '現場で復旧できなかった場合には、レッカー車の応援も呼べますのでご安心ください。',
  WRECKER:
    'この後、運び先へ「お車の受け入れ可能か」確認してください。確認できない場合は到着したスタッフにご相談ください。',
  INTRODUCTION:
    '※工場の詳細については、オペレーターよりご連絡します。\n※修理工場までお運びした段階で、サービス終了となります。\n※修理費用など、お客様都合での再度のお運びはできません。',
}

/**
 * エラーメッセージ
 */
export const ERROR = {
  CONTAINS_SURROGATE_PAIR: '使用できない文字が入力されています',
}
